import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/opg-sim/OPG_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/opg-sim/OPG_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/opg-sim/OPG_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/opg-sim/OPG_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/opg-sim/OPG_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/opg-sim/OPG_Slider_6.jpg';
import projectImage7 from '../../../../assets/images/work/opg-sim/OPG_Slider_7.jpg';

import Data_OPGIncidentCommand from './Data_OPGIncidentCommand';

function Work_OPGIncidentCommand() {
    return (
        <>
            <DetailedHeader
                heading="Leading the Response Before It’s Real"
                client="Ontario Power Generation"
                service="Simulation Tool"
                date="2025-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage7,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_OPGIncidentCommand.content}
        </>
    );
}

export default Work_OPGIncidentCommand;
